import { render, staticRenderFns } from "./RelayEdit.vue?vue&type=template&id=692e179b"
import script from "./RelayEdit.vue?vue&type=script&lang=ts"
export * from "./RelayEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports